export const weekdayDateMonth = (date, locale) => {
    let newDate = new Date(date).toLocaleDateString('sv', {
        weekday: 'long',
        day: 'numeric',
        month: 'long',
    });


    return dateToUpperCase(newDate);
};


export const isDotNetDate = (unknownDate) => {
    if (unknownDate.toString().includes('/Date')) return true;
    
    return false;
};

export const convertDotNetDateToJSDate = (dotNetDate) => {
    dotNetDate = dotNetDate.replace(/\/Date\((-?\d+)\)\//, '$1');
    return new Date(parseInt(dotNetDate));
};


function dateToUpperCase(dateString) {
    dateString = dateString.split(' ').map((stringPart) => {
        if (!/^\d+$/.test(stringPart)) {
            return stringPart.charAt(0).toUpperCase() + stringPart.slice(1);
        } else {
            return stringPart;
        }
    }).join(' ');

    return dateString;
}
